module.exports = __webpack_public_path__ + "static/media/test.34e86f06.jpg";